import { isPlatform } from "@ionic/react";
import { ILocalStorageModel } from "../models/LocalStorage.Model";
import { HelperConstant } from "./HelperConstant";
import { ITokenModel } from "models/ITokenModel";
import jwt_decode from 'jwt-decode';
import Dashboard from "pages/Dashboard";
import { useTypedSelector } from "features/reduxhooks/ReduxHooks";
import { Directory, Filesystem, WriteFileResult } from "@capacitor/filesystem";
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener';
import { LocalNotifications, ScheduleOptions } from "@capacitor/local-notifications";

var CryptoJS = require("crypto-js");

export const AES_EncryptionKey = "DOFYSEKEYAE$2024";

export const responsiveItemPerView = (mobileView: number, webView: number) => {
    let view: number;
    if (isPlatform('android') || isPlatform('ios')) {
        view = mobileView;
    } else {
        view = webView;
    }

    return view;
}

export const isMobile = () => {
    if (isPlatform("tablet")) {
        return false
    }
    else if (isPlatform('android') || isPlatform('ios')) {
        return true;
    } else {
        return false;
    }
}

export const isTablet = () => {
    if (isPlatform("desktop")) {
        return false
    }
    else if (isPlatform("tablet")) {
        return true;
    } else {
        return false;
    }
}

export const GetLocation = (pathRef: any) => {
    let data = localStorage.getItem('LanguageCode');
    if (data === null || data === undefined || !data) window.location.href = `/${pathRef}`;
}

export const GetHome = (data: any, pathRef: any) => {
    if (data === 0 || data === null || data === undefined || !data) window.location.href = `/${pathRef}`;
}

export const getLocalStorage = () => {
    let token: { Token: any } = JSON.parse(localStorage.getItem("authUser") as any);
    return token ? token : {} as { Token: any }
}

export const getCountryCodeStorage = () => {
    let item: string = localStorage.getItem("CountryCode") as string;
    return item ? item : "in";
}

export const restrictInput = (e: any, maxLength: number) => {
    if (e.target.value.length > maxLength) {
        e.target.value = e.target.value.slice(0, maxLength);
    }
}

export const onKeyDown = (e: any) => {
    // return ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
    // return isNaN(e.key) && e.preventDefault();

    // temporary solution for tablet need to be changes.
    return ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '+', '-', '.', '!', '@', '#', '$', '%',
        '^', '&', '*', '(', ')', '`', '~', '>', '<', ',', '.', '?', '/', '[', ']', '{', '}', '|', '=', '_', '/', '₹', ';', ':', "'", '"', " "].includes(e.key.toLowerCase()) && e.preventDefault();
}

export const toAmount = (amount: any) => {
    return amount?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const isValidUser = (token: any) => {
    const loginUser = getLocalStorage().Token;
    const isUser = token?.RoleId;

    if (loginUser === null || (isUser === HelperConstant.Roles.Public.toString())) {
        return window.location.href = "/login";
    }
}

export const isValidUserAuthenticate = (token: any) => {
    const isUser = token?.RoleId;

    let seoRouter = window.location.pathname.includes("seo");
    let HomeRouter = window.location.pathname.includes("homepage");

    if ((isUser === HelperConstant.Roles.SEO.toString() && !seoRouter)) {
        return window.location.href = "/seo";
    }
    // if ((isUser === HelperConstant.Roles.Rider.toString() && !HomeRouter)) {
    //     return window.location.href = "/homepage";
    // }

}

export const isValidUserAuthenticateForSeo = (token: any) => {
    const isUser = token?.RoleId;

    let seoRouter = window.location.pathname.includes("seo");

    if ((isUser === HelperConstant.Roles.SEO.toString() && seoRouter)) {
        return window.location.href = "/seo";
    }

}

export const HandleHomepage = (token: any) => {
    let tokendata: ITokenModel = jwt_decode(token);
    switch (parseInt(tokendata?.RoleId)) {
        case HelperConstant.Roles.SEO:
            return window.location.href = "/seo";

        default:
            return window.location.href = "/homepage";
    }

}

export const isLogginUser = () => {
    const loginUser = getLocalStorage().Token;

    if (loginUser) {
        return window.location.href = "/";
    }
}
export const countrycodenumber = (val: any) => (val ? isIn() ? '+91-' : "+971-" : "");

export const findPostiveNumber = (num: number) => (num < 0) ? "text-danger fw-semibold" : "text-success fw-semibold";

export const changePostiveNumber = (num: number) => (num < 0) ? num * -1 : num;

export const getStatusIds = (statsId: number) => {
    switch (statsId) {
        case 1:
            return null;
        case 2:
            return `${HelperConstant.StatusId.SCHEDULED},${HelperConstant.StatusId.RESCHEDULED}`;
        case 3:
            return `${HelperConstant.StatusId.INPROGRESS},${HelperConstant.StatusId.ASSIGNED},${HelperConstant.StatusId.REQUOTE},${HelperConstant.StatusId.DELAYED}`;
        case 4:
            return HelperConstant.StatusId.COMPLETED;
        case 5:
            return HelperConstant.StatusId.FAILED;
        case 6:
            return HelperConstant.StatusId.CANCEL_REQUEST;
        case 7:
            return HelperConstant.StatusId.CANCELLED;
        case 8:
            //return HelperConstant.StatusId.PENDING;

            return `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`;

        case 9:
            return HelperConstant.StatusId.RETURN;
        default:
            return;
    }
}

export const getStatusName = (dashboardName?: number) => {
    switch (dashboardName) {
        case 1:
            return ('All');
        case 2:
            return ('Open');
        case 3:
            return ('In-Progress');
        case 4:
            return ('Completed');
        case 5:
            return ('Failed')
        case 6:
            return ('Cancel Requested')
        case 7:
            return ('Cancelled')
        case 8:
            return ('Pending')
        case 9:
            return ('Return')
        default:
            return;
    }
}
export const getUserLanguage = (): "in_en" | "ae_en" | "ae_ar" => {
    let in_en = window.location.href.includes('in_en');
    let ae_en = window.location.href.includes('ae_en');
    let ae_ar = window.location.href.includes('ae_ar');
    if (in_en) {
        localStorage.setItem("Ln", 'in_en');
        return "in_en";
    }
    if (ae_en) {
        localStorage.setItem("Ln", 'ae_en');
        return "ae_en";
    }
    if (ae_ar) {
        localStorage.setItem("Ln", 'ae_ar');
        return "ae_ar";
    }
    else {
        localStorage.setItem("Ln", 'in_en');
        return "in_en";
    }
}

export const RTLDirection = () => {
    let htmlElements = document.querySelectorAll('.rtl');
    if (getUserLanguage() == "ae_ar") {
        htmlElements.forEach(element => (
            element?.setAttribute("dir", "rtl")
        ));
    }
    else {
        htmlElements.forEach(element => (
            element?.removeAttribute("dir")
        ));
    }
}

export const Direction = (): "rtl" | "ltr" => {
    if (getUserLanguage() == "ae_ar") {
        return "rtl";
    }
    else {
        return "ltr";
    }
}

export const isRTL = () => {
    if (getUserLanguage() == "ae_ar") {
        return true;
    }
    else {
        return false;
    }
}

export const isIn = () => {
    if (getCountryCodeStorage() == "in") {
        return true;
    }
    else {
        return false;
    }
}

export const currencyByCountry = (amount: any) => {
    if (getCountryCodeStorage() == "in") {
        return `Rs. ${(amount)?.toLocaleString()}`;
    }
    // return `Æ ${amount}`;
    return `${amount} AED`;
}

export const findedLocation = (): { LanguageCode: string, CountryCode: string } => {
    let CountryCode = localStorage.getItem('CountryCode');
    let LanguageCode = localStorage.getItem('LanguageCode');

    if (CountryCode == 'ae' && LanguageCode == "ar") {
        return { LanguageCode: "ar", CountryCode: "ae" }
    }
    if (CountryCode == 'ae' && LanguageCode == "en") {
        return { LanguageCode: "en", CountryCode: "ae" }
    }
    else {
        return { LanguageCode: "en", CountryCode: "in" }
    }
}

export const getTokenDetail = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata;
    }
    catch (Error) {
        return null;
    }
}

export const formTypeHandler = () => {
    let isEdit = window.location.pathname.includes("edit");
    let id: any;
    if (isEdit) {
        id = window.location.pathname.split("/").at(-1);
    }
    return { isEdit, id };

}
export const encodeParam = (param: any): any => {
    let encodedId = param;
    return encodedId;
};

export const decodeParam = (param: any): any => {
    if (param) {
        let decodedId = param;
        return decodedId;
    } else {
        return param;
    }
};

export const ID_EncryptionKey = "DOFYADMINAES2024";

export const encryptOrderId = (id) => {
    //For AES Encryption
    const encryptedId = CryptoJS.AES.encrypt((id)?.toString(), ID_EncryptionKey, { keySize: 128, iv: ID_EncryptionKey, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString();
    const wordArray = CryptoJS.enc.Base64.parse(encryptedId);
    const hexCode = wordArray.toString(CryptoJS.enc.Hex);
    return hexCode;
}


export const decryptOrderId = (encryptedId: any) => {
    //For AES Decryption
    let wordArrays = CryptoJS.enc.Hex.parse(encryptedId)
    let base64String = CryptoJS.enc.Base64.stringify(wordArrays)
    var bytes = CryptoJS.AES.decrypt(base64String, ID_EncryptionKey, { keySize: 128, iv: ID_EncryptionKey, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    var decryptedId = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedId;
}

const keyValue = CryptoJS.enc.Utf8.parse(AES_EncryptionKey);

export const aes_encryption = (id: any) => {
    let encryptedId = CryptoJS.AES.encrypt((id)?.toString(), keyValue, { keySize: 128 / 8, iv: keyValue, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString();
    let modifiedEncryptedValue = encryptedId.replaceAll("/", "_").replaceAll("+", "-");
    return modifiedEncryptedValue;
}



export const aes_decryption = (encryptedId: any) => {
    let base64 = encryptedId.replaceAll("_", "/").replaceAll("-", "+");
    var bytes = CryptoJS.AES.decrypt(base64, keyValue, { keySize: 128 / 8, iv: keyValue, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    var decryptedId = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedId;
}



export const checkIsAccess = (ActivityMasterId: "1" | "2" | "3" | "4" | "5", ScreenName: string) => {
    let groupedMenuList = JSON.parse(localStorage.getItem("GroupedMenuList") as any);
    let routes = Object.values(groupedMenuList).flatMap(item => Array.isArray(item) ? item : [item]);
    let accessedRoutes = routes.filter(x => x.HasAccess == true && x.ScreenName == ScreenName && x.ActivityMasterId == ActivityMasterId);
    return accessedRoutes.length > 0;
}

export const properHeader = (val: string, type: "LanguageCode" | "CountryCode") => {
    if (val == "" && type === "LanguageCode") {
        return findedLocation().LanguageCode;
    }
    if (val == "" && type === "CountryCode") {
        return findedLocation().CountryCode;
    }
    return val;
}

export const ResponsiveItemPerView = (mobileView: number, webView: number, tabletView?: number, xlScreen?: number) => {
    let isMobile = useTypedSelector(state => state.FindDevice.isMobile);
    let isTablet = useTypedSelector(state => state.FindDevice.isTablet);
    let isXLScreen = useTypedSelector(state => state.FindDevice.isExtraLarge);
    let isDesktop = useTypedSelector(state => state.FindDevice.isDesktop);

    let view: number;

    if (isMobile) {
        view = mobileView;
        return view;
    }
    if (isTablet) {
        view = tabletView ? tabletView : (webView / 2);
        return view;
    }
    if (isDesktop) {
        view = webView;
        return view;
    }

    if (isXLScreen) {
        view = xlScreen ? xlScreen : webView;
        return view;
    }

    return webView;
}

export const onSpaceDown = (e: any) => {
    return [" "].includes(e.key.toLowerCase()) && e.preventDefault();
}

export const downloadMobileInvoice = async (file: any, path: any) => {
    Filesystem.writeFile({
        path: path,
        data: file,
        directory: Directory.Documents,
        recursive: true
    }).then((res: WriteFileResult) => {
        showInvoiceNotification(res.uri, path);
    }).catch(e => console.log(e));
};

const openDownloadedFile = async (uri: any) => {
    try {
        const fileOpenerOptions: FileOpenerOptions = {
            filePath: uri,
            openWithDefault: true,
        };
        await FileOpener.open(fileOpenerOptions);

    } catch (e) {
        console.log('Error opening file', e);
    }
};

const showInvoiceNotification = async (uri: any, name: any) => {
    let options: ScheduleOptions = {
        notifications: [
            {
                id: 1,
                title: name,
                body: "Download completed. File saved in Documents",
                extra: { uri: uri },
                actionTypeId: "open_pdf"
            }
        ]
    };

    try {
        await LocalNotifications.schedule(options);
    } catch (error) {
        console.log(error);
    }

    LocalNotifications.addListener('localNotificationActionPerformed', async (notification) => {
        if (notification.notification.actionTypeId === 'open_pdf') {
            const uri = notification.notification.extra.uri;
            openDownloadedFile(uri);
        }
    });
}

export const downloadCSV = (csvData: any, fileName: string) => {
    const decodedData = atob(csvData);
    const blob = new Blob([decodedData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
};

export const loadConfigforImageCdnUrl = async () => {
    const response = await fetch("/config.json");
    const config = await response.json();
    return config.CDN__IMAGE_URL;
};

export const loadConfigforImageApiUrl = async () => {
    const response = await fetch("/config.json");
    const config = await response.json();
    return config.IMAGE_API_URL;
};